Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-product-compare-list'),
        wrapper;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    var model = null;

    wrapper.loading = function loading (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.extendModel = function () {
        model = { ...model, ...{ ClientEnhancedModel: window.LhApp.ClientEnhancedModel } }; // model to be expanded from page html (window.LhApp = window.LhApp || {}; window.LhApp.ClientEnhancedModel = window.LhApp.ClientEnhancedModel || {};
    };

    wrapper.calcHeight = function () {
        var $boxes = $('.x-product-compare-box', $wrapper);
        var maxHeight = 0;

        $boxes.each(function (index) {
            var $box = $(this);
            var height = $('.control-area-one', $box).height();

            if (height > maxHeight) {
                maxHeight = height;
            } else {
                $('.control-area-one', $box).height(maxHeight);
            }              
        });
    };

    wrapper.updateScrollButtons = function () {
        var $compareList = $('.product-compare-list', $wrapper);
        var $scrollActions = $('.product-compare-scroll-actions', $wrapper);
        var $scrollLeftButton = $('.js-product-compare-scroll-left', $wrapper);
        var $scrollRightButton = $('.js-product-compare-scroll-right', $wrapper);

        if ($compareList.length < 1) return;

        var compareList = $compareList.get(0);
        var hasOverflow = compareList.scrollWidth > compareList.clientWidth;
        var scrollLeft = compareList.scrollLeft;
        var maxScrollLeft = compareList.scrollWidth - compareList.clientWidth;
        var canScrollLeft = hasOverflow && scrollLeft > 0;
        var canScrollRight = hasOverflow && scrollLeft < maxScrollLeft;

        $scrollActions.toggleClass('hidden', !hasOverflow);
        $('.product-features', $wrapper).toggleClass('has-scrollbar', hasOverflow);
        $scrollLeftButton.toggleClass('disabled', !canScrollLeft);
        $scrollRightButton.toggleClass('disabled', !canScrollRight);
    };

    wrapper.bindScrollEvents = function () {
        var $compareList = $('.product-compare-list', $wrapper);

        if ($compareList.length < 1) return;

        var scrollAmount = Math.max(Math.floor($compareList.outerWidth() * 0.6), 200);

        $('.js-product-compare-scroll-left', $wrapper).off('click').on('click', function () {
            $compareList.animate({ scrollLeft: $compareList.scrollLeft() - scrollAmount }, 500);
        });

        $('.js-product-compare-scroll-right', $wrapper).off('click').on('click', function () {
            $compareList.animate({ scrollLeft: $compareList.scrollLeft() + scrollAmount }, 500);
        });

        $compareList.off('scroll.productCompare').on('scroll.productCompare', function () {
            wrapper.updateScrollButtons();
        });

        $(window).off('resize.productCompare').on('resize.productCompare', function () {
            wrapper.updateScrollButtons();
        });

        wrapper.updateScrollButtons();
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse(Handlebars.partials.productCompareList_A, model);

        wrapper.bind(html);

        //wrapper.calcHeight();

        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);

        formatPrices($wrapper);

        Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));

        wrapper.bindScrollEvents();
    };

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.Changed, wrapper, function (envelope) {
        wrapper.loading(true);
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetModel());
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.GetModelSuccess, wrapper, function (envelope) {
        model = envelope.message.data.model;

        wrapper.loading(true);
        wrapper.extendModel();
        wrapper.update();
    });

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetModel());
});